import type { TaskListScope } from "@asap/shared/schemas/task/crud";

export const TASK_SCOPES = [
  { labelKey: "tasks.page.scopes.assignedToMe", value: "assigned_to_me" },
  { labelKey: "tasks.page.scopes.delegatedToMe", value: "delegated_to_me" },
  { labelKey: "tasks.page.scopes.myTeam", value: "my_team" },
] as const satisfies readonly { labelKey: string; value: TaskListScope }[];

export const DEFAULT_TASK_SCOPE = TASK_SCOPES[0].value;

export type TaskScope = (typeof TASK_SCOPES)[number]["value"];

const isValidTaskScope = (value: unknown): value is TaskScope =>
  TASK_SCOPES.some((scopeOption) => scopeOption.value === value);

export const getTaskScopeFromQuery = (value: unknown): TaskScope => {
  if (Array.isArray(value)) {
    const firstValue = value[0];
    if (isValidTaskScope(firstValue)) {
      return firstValue;
    }
    return DEFAULT_TASK_SCOPE;
  }

  if (isValidTaskScope(value)) {
    return value;
  }

  return DEFAULT_TASK_SCOPE;
};
